<template>
  <v-card class="mt-2" elevation="0">
    <v-card-title class="pt-1 headline font-weight-regular">
      Experiences
    </v-card-title>
    <highlight-change v-if="isNewSection" :delta-value="deltaSection"></highlight-change>
    <v-card-text>
      <v-list>
        <div v-for="(job, key) in jobs" :key="key" class="py-0 mb-2">
          <single-job-mocker v-if="job.job" :job="job"></single-job-mocker>
          <multiple-job-mocker v-else :job="job"></multiple-job-mocker>
          <highlight-change v-if="deltaSection && !isNewSection" :delta-value="deltaSection[key]"></highlight-change>
        </div>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
  import HighlightChange from "../../Widgets/highlightChange";
  import SingleJobMocker from "./singleJobMocker";
  import MultipleJobMocker from "./multipleJobMocker";

  export default {
    name: "jobsMocker",
    components: {MultipleJobMocker, SingleJobMocker, HighlightChange},
    props: ['jobs', 'deltaSection'],
    computed: {
      isNewSection(){
        return this.deltaSection && (this.deltaSection[0] === false || this.deltaSection[1] === false);
      }
    }
  }
</script>

<style scoped>
  .article-title {
    line-height: initial;
  }
</style>



// WEBPACK FOOTER //
// src/components/Mockers/Lin/jobsMocker.vue